import React from 'react';
import styles from './SuperLogo.module.css';

function SuperLogo() {
  return (
    <h1 className={ styles.logo_stage }>
      {/* <strong className={ styles.super }>Super</strong>
      <strong className={ styles.trunfo }>Trunfo</strong> */}
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
      <strong className={ styles.super } />
    </h1>
  );
}

export default SuperLogo;
